<template>
  <v-dialog v-model="mppDialog" :width="hasFetchedData ? '90%' : '400px'">
    <template v-slot:activator="{ on }">
      <mf-button label="Magic Price Point" @click="mppDialog = true" />
    </template>
    <v-card class="pa-2 mpp-card">
      <v-card-title class="pb-0">
        <span>Magic Price Point</span>
        <v-spacer />
        <filters-menu v-if="hasFetchedData" :filters="['lojas', 'data']" default-date="ultimosTrintaDias" />
      </v-card-title>

      <v-card-text class="py-0">
        <p class="title mb-2">{{ produtoSelecionado && produtoSelecionado.name }}</p>
        <p class="caption mb-0">{{ produtoSelecionado && produtoSelecionado.sku }}</p>
        <v-layout align-center justify-center>
          <span class="mb-1 mr-1 subheading">Custo</span>
          <v-text-field v-model="costInput" v-money="costInputConfigs" class="custo" autofocus @keyup.enter="getData" />
          <mf-button size="sm" :loading="$wait.is('mpp-loader')" label="Calcular" @click="getData" />
          <v-spacer v-if="hasFetchedData" />
        </v-layout>
      </v-card-text>
      <v-data-table v-if="hasFetchedData" class="mpp-data-table" :items="mppItems" :headers="mppHeaders" hide-default-footer disable-pagination>
        <template v-slot:item="{ item }">
          <tr>
            <td class="text-right">{{ item['VAL_VALOR_UNIT'] | localeString(2) | currency }}</td>
            <td class="text-right">{{ item['NUM_DIAS'] | localeString }} dias</td>
            <td class="text-right">{{ item['VAL_QUANTIDADE_KG'] | localeString }}</td>
            <td class="text-right">{{ item['EST_QUANTIDADE_DIARIA'] | localeString(1) }}</td>
            <td class="text-right">{{ item['EST_FATURAMENTO_DIARIO'] | localeString(2) | currency }}</td>
            <td class="text-right">{{ item['EST_CUSTO_DIARIO'] | localeString(2) | currency }}</td>
            <td class="text-right">{{ item['EST_MARGEM_UNITARIA'] | localeString(1) | percent }}</td>
            <td class="text-right">{{ item['EST_CONTRIBUICAO_DIARIA'] | localeString(2) | currency }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import { VMoney } from 'v-money'

export default {
  components: {
    FiltersMenu: () => import('@/components/FiltersMenu.vue'),
  },
  directives: { money: VMoney },
  props: {
    produtoSelecionado: Object,
  },
  data: () => ({
    mppDialog: false,
    costInput: '000',
    hasFetchedData: false,
    costInputConfigs: { decimal: ',', thousands: '.', prefix: 'R$ ', precision: 2, masked: false },
  }),
  computed: {
    ...mapState({ stateFilters: (state) => state.filters }),
    ...mapGetters({
      mppGetter: 'magicPricePoint',
    }),
    mppItems() {
      return this.mppGetter['table']
    },
    mppValue() {
      return this.mppGetter['mpp']
    },
    mppHeaders() {
      return [
        {
          text: 'Preço unit.',
          value: 'VAL_VALOR_UNIT',
          align: 'right',
        },
        {
          text: 'Período',
          value: 'NUM_DIAS',
          align: 'right',
        },
        {
          text: 'Quant. vendida',
          value: 'VAL_QUANTIDADE_KG',
          align: 'right',
        },
        {
          text: 'Média diária',
          value: 'EST_QUANTIDADE_DIARIA',
          align: 'right',
        },
        {
          text: 'Fat. médio diário',
          value: 'EST_FATURAMENTO_DIARIO',
          align: 'right',
        },
        {
          text: 'Custo médio diário',
          value: 'EST_CUSTO_DIARIO',
          align: 'right',
        },
        {
          text: 'Margem unit.',
          value: 'EST_MARGEM_UNITARIA',
          align: 'right',
        },
        {
          text: 'Contrib. diária',
          value: 'EST_CONTRIBUICAO_DIARIA',
          align: 'right',
        },
      ]
    },
    filter() {
      return {
        produto: this.produtoSelecionado.sku,
        custo: this.costInputNumber,
        unidade: this.stateFilters.unitsConfiguration,
        date: this.stateFilters.data,
      }
    },
    costInputNumber() {
      let cost = this.costInput
      cost = cost.substring(3)
      cost = cost.split('.').join('').replace(',', '.')
      return parseFloat(cost)
    },
  },
  async mounted() {
    await this.getDataFiltrar()
    this.$nextTick(() => {
      this.$bus.$on('filter', this.getDataFiltrar)
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    ...mapWaitingActions({
      magicPricePoint: 'mpp-loader',
    }),
    getData() {
      if (!isNaN(this.costInputNumber)) {
        const filter = { ...this.filter, custo: this.costInputNumber }
        this.magicPricePoint(filter)
          .then(() => {
            this.hasFetchedData = true
          })
          .catch(() => {
            this.hasFetchedData = false
            this.$snackbar({ message: 'Não foi possível calcular o MPP', snackbarColor: 'error' })
          })
      }
    },
    getDataFiltrar() {
      if (this.costInputNumber !== 0) this.getData()
    },
  },
}
</script>

<style lang="scss">
.mpp-card {
  .custo {
    max-width: 88px;
  }
  input::-webkit-inner-spin-button,
  input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .filters-margins {
    margin-top: -24px;
    margin-bottom: -24px;
  }
  .mpp-data-table {
    max-height: 320px;
    overflow-y: auto;
  }
}
</style>
